export default "__VITE_ASSET__ySIL$8hN__"